import React, { useEffect, useState } from 'react'
import MainActions from './MainActions'
import UserMenu from './UserMenu'
import { useAuth0 } from '@auth0/auth0-react'
import style from './style.module.scss'
import { Button, Dropdown, Menu, Tabs, Tooltip } from 'antd'
import {
  DownloadOutlined,
  AreaChartOutlined,
  CloudSyncOutlined, QuestionCircleOutlined, BookOutlined
} from '@ant-design/icons'
import { useHistory, useLocation } from 'react-router-dom'
import {connect, useSelector} from 'react-redux'
import { useData } from '../../../../contexts/data-context'
import moment from 'moment'
import { datasetsService } from 'services/api/datasets.service'

import SYNC_IMAGE from '../../HcManager/assets/sync.png'
import SYNC_LOADING_GIF from '../../HcManager/assets/sync_loading.gif'
import getSubdomainTask, {checkTaskRunning, trackEvent} from '../../../../services/utils'
import bookOpened from "../../../cleanui/InfoLink/book-open.svg";
import AppsMenu from "./AppsMenu";
import {
  setActiveSidebarArticles,
  setActiveSidebarSection,
  toggleSidebarCollapsed
} from "../../../../redux/sidebar/actions";
import { INTERCOM_PROVIDER, ZENDESK_PROVIDER } from 'components/swifteq/Helpdesk/Connect/utils'

const mapStateToProps = ({ settings }) => ({
  logo: settings.logo,
})

const TopBar = ({ logo }) => {
  const location = useLocation()
  const history = useHistory()
  const { is_customer, init_status, product, payment_link, default_dataset, setDefaultDataset, subdomain } =
    useData()
  const [activeKey, setActiveKey] = useState('1')

  const { getAccessTokenSilently, user } = useAuth0()

  const isViewOnly = user?.['https://www.swifteq.com/role'] === 'view-only';

  const loading_task = getSubdomainTask(default_dataset, 'load', subdomain)
  const links_task = getSubdomainTask(default_dataset, 'hcm_links', subdomain)
  const any_task_running = checkTaskRunning(default_dataset, subdomain);

  const [isWidthSmall, setIsWidthSmall] = useState(false);

  const activeSectionArticles = useSelector((state)=> state?.sidebarReducer.activeSectionArticles)

  useEffect(() => {
    window.addEventListener('error', e => {
      if (e.message === 'ResizeObserver loop limit exceeded' || e.message === 'Script error.') {
        const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
        )
        const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay'
        )
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
      }
    })
    const handleResize = () => {
      setIsWidthSmall(window.innerWidth < 1500);
    };

    // Add event listener to window resize event
    window.addEventListener('resize', handleResize);

    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };


  }, []);

  useEffect(() => {
    if (location && location.pathname) {
      if (product === "hcmanager") {
        if (location.pathname.includes('articles')) setActiveKey('1')
        else if (location.pathname.includes('media')) setActiveKey('3')
        else if (location.pathname.includes('links')) setActiveKey('2')
        else if (location.pathname.includes('analytics') && location.pathname.includes('details')) setActiveKey('5')
        else if (location.pathname.includes('analytics')) setActiveKey('4')
      }
      else {
        if (location.pathname.includes('analytics')) setActiveKey('1')
      }
    }
  }, [])

  const title = {
    answersearch: 'Answer Search for Zendesk',
    easydoc: 'Help Center Export for Zendesk Guide',
    hcmanager: 'Help Center Manager for Zendesk Guide',
    hcanalytics: 'Help Center Analytics for Zendesk Guide',
    hctranslate: 'Help Center Translate for Zendesk Guide',
    mergedup: 'Merge Duplicate Tickets for Zendesk',
    removecc: 'Remove CC from Zendesk Tickets',
    attachments: 'Attachment Workflows for Zendesk',
  }

  const helpCenterNameMapper = {
    [ZENDESK_PROVIDER]: `https://${subdomain}`,
    [INTERCOM_PROVIDER]: `https://intercom.help/${subdomain}`,
    'default': `https://${subdomain}`
  }

  const go_home = (e) => {
    e.preventDefault()
    handleTabClick('1')
    setActiveSidebarArticles('Home')
    localStorage.setItem('activeSidebarArticles','Home')
  }

  const { TabPane } = Tabs

  const handleTabClick = (tabKey) => {
    if (product === "hcmanager") {
      if (tabKey === '1') history.push('/home')
      else if (tabKey === '2') history.push('/links')
      else if (tabKey === '3') history.push('/media')
      else if (tabKey === '4') {
        localStorage.removeItem('prevUrl')
        history.push('/analytics')
      }
      else if (tabKey === '5') history.push('/analytics/details')
    }
    else if (product === "hctranslate") {
      history.push('/articles')
    }
    else {
      if (tabKey === '1') history.push('/analytics')
      else if (tabKey === '2') history.push('/analytics/details')
    }
    if(location.pathname !== window.location.pathname) {
      setActiveKey(tabKey)
    }
  }

  const handleSyncArticles = async (cont) => {
    try {
      if (any_task_running) return;

      trackEvent('Sync', {cont: cont, subdomain})

      if (default_dataset && subdomain) {
        let sync_subdomain = default_dataset.source === ZENDESK_PROVIDER ? subdomain : "intercom";
        const token = await getAccessTokenSilently()
        await datasetsService.syncArticles(token, default_dataset._id, product, sync_subdomain, cont)
        const new_default_dataset = await datasetsService.getOneDataset(
          token,
          default_dataset._id,
          subdomain,
        )
        setDefaultDataset(new_default_dataset)
        localStorage.removeItem('showFindAndReplaceResult')
      }
    } catch (e) {
      console.error(e)
    }
  }

  const syncDropdownMenu = (taskRunning) => {
    if (taskRunning)
      return <div/>
    return (
      <Menu>
        <Menu.Item>
          <a onClick={() => handleSyncArticles(true)}
          >
            <CloudSyncOutlined className="mr-2" />
            Quick Sync
          </a>
        </Menu.Item>
        <Menu.Item>
          <a onClick={() => handleSyncArticles(false)} className="mr-3"
          >
            <DownloadOutlined className="mr-2" />
            Full Sync
          </a>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <a href="https://support.swifteq.com/hc/en-us/articles/21959793331473-Syncing-the-Zendesk-Data-to-Help-Center-Manager" target="_blank"
          >
            <QuestionCircleOutlined className="mr-2" />
            Learn More
          </a>
        </Menu.Item>
      </Menu>
    )

  }

  const renderEasyDocTitle = () => {
    return (
      <div className="d-flex flex-row h-100">
        <span>Help Center
          {product === 'hcanalytics' ? ' Analytics' : (product === 'hctranslate' ? ' Translate' : ' Manager')}</span>
        <div className="ml-5" style={{ position: 'relative', top: -10 }}>
          <Tabs
            onTabClick={(tabKey) => handleTabClick(tabKey)}
            activeKey={activeKey}
            defaultActiveKey="1"
          >
            {(product === 'hcmanager' || product === 'hctranslate') &&
              <TabPane
                tab={
                  <span>
                  <BookOutlined />
                  Content
                </span>
                }
                key="1"
              ></TabPane>}
            {/*{product === 'hcmanager' &&*/}
            {/*  <TabPane*/}
            {/*    tab={*/}
            {/*      <span>*/}
            {/*      <LinkOutlined />*/}
            {/*      Links*/}
            {/*    </span>*/}
            {/*    }*/}
            {/*    key="2"*/}
            {/*  ></TabPane>}*/}
            {/*{product === 'hcmanager' &&*/}
            {/*  <TabPane*/}
            {/*    tab={*/}
            {/*      <span>*/}
            {/*      <FileImageOutlined />*/}
            {/*      Media*/}
            {/*    </span>*/}
            {/*    }*/}
            {/*    key="3"*/}
            {/*  ></TabPane>}*/}
            {(product === 'hcmanager' || product === 'hcanalytics') && <TabPane
              tab={
                <span>
                  <AreaChartOutlined />
                  Analytics
                </span>
              }
              key={product === 'hcanalytics' ? "1" : "4"}
            ></TabPane>}
          </Tabs>
        </div>
      </div>
    )
  }

  return (
    <div className={style.topbar}>
      <div className="mb-0 d-xl-block">
        <div className={style.logoContainer}>
          <div className={style.logo}>
            <a onClick={go_home}>
              <img
                src="/resources/images/logo.svg"
                className={`mr-2 ${style.logoImage}`}
                alt="Swifteq"
              />
            </a>
            {/*<div className={style.name}>{logo}</div>*/}
            <div className={style.descr}>
              {product === 'hcmanager' || product === 'hcanalytics' || product === 'hctranslate' ? renderEasyDocTitle() : title[product] || 'Loading...'}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="mb-0 mr-auto d-xl-block d-none">
        <MainActions />
      </div> */}
      <div className="d-flex ml-auto" style={{ maxHeight: 64 }}>
        {init_status === 'ready' && !isWidthSmall && default_dataset.source === ZENDESK_PROVIDER && (
          <div className="ml-3 mr-3">
            <div className="d-flex flex-column ">
              <div style={{ maxHeight: 17 }}>
                <span style={{ fontSize: 13 }}>Help Center</span>
              </div>
              <div style={{ maxHeight: 10 }}>
                <a href={helpCenterNameMapper[default_dataset.source]} target="_blank">
                  <strong style={{ fontSize: 13 }}>{subdomain}</strong>
                </a>
              </div>
            </div>
          </div>
        )}
        {init_status === 'ready' && (
          <div className="d-flex flex-row mr-4">
            {
              !isWidthSmall ?
                <div className="ml-3 mr-3 hideOnSmallerScreens">
                  <div className="d-flex flex-column">
                    <div style={{ maxHeight: 17 }}>
                      <span style={{ fontSize: 13 }}>Articles</span>
                    </div>
                    <div style={{ maxHeight: 10 }}>
                      <strong style={{ fontSize: 13 }}>{loading_task.total}</strong>
                    </div>
                  </div>
                </div> : null
            }

            {
              !isWidthSmall ?
                <div className="ml-3 mr-3 hideOnSmallerScreens">
                  <div className="d-flex flex-column">
                    <div style={{ maxHeight: 17 }}>
                      <span style={{ fontSize: 13 }}>Last Sync</span>
                    </div>
                    <div style={{ maxHeight: 10 }}>
                      <strong style={{ fontSize: 13 }}>
                        {moment(loading_task.ts).format('ll HH:mm')}
                      </strong>
                    </div>
                  </div>
                </div> : null
            }

            <Tooltip
              title={
                any_task_running
                  ? 'Syncing cannot be executed while other tasks are running. Please wait until the current task is finished.'
                  : ''
              }
            >
              <div
                className="ml-3 mr-3 d-flex align-items-center justify-content-center"
              >
                <Dropdown overlay={syncDropdownMenu(any_task_running)}
                          placement="bottomLeft"
                          trigger={['click']}>
                  <div
                    style={{
                      height: 35,
                      width: 35,
                      background: 'rgba(0,0,0,0.1)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: 50,
                      cursor: 'pointer',
                    }}
                  >
                    <img
                      src={
                        loading_task.status === 'running' || links_task.status === 'running'
                          ? SYNC_LOADING_GIF
                          : SYNC_IMAGE
                      }
                      height={25}
                      width={25}
                    />
                  </div>
                </Dropdown>
              </div>
            </Tooltip>
          </div>
        )}
        {!is_customer && (
          <a
            className="btn btn-primary btn-small align-middle mr-5"
            style={{ height: '50%'}}
            href={'/payment'}
            type="button"
          >
            Subscribe
          </a>
        )}
        {!isViewOnly && (!default_dataset || default_dataset?.source === 'zendesk_support') && <AppsMenu />}
        <UserMenu />
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  setActiveSidebarSection: (section) => dispatch(setActiveSidebarSection(section)),
  setActiveSidebarArticles: (section) => dispatch(setActiveSidebarArticles(section)),
  toggleSidebarCollapsed: () => dispatch(toggleSidebarCollapsed()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);
